import Box from "@mui/material/Box";
import { memo } from "react";
import SimpleBar from "simplebar-react";

import MenuContent from "@/layout/Sidebar/MenuContent";
import SidebarLogo from "@/layout/Sidebar/SidebarLogo";
import { SidebarDrawer } from "@/layout/styles";

const CasinoSidebar = memo(() => {
  return (
    <SidebarDrawer variant="permanent">
      <SidebarLogo />
      <Box component={SimpleBar}>
        <MenuContent />
      </Box>
    </SidebarDrawer>
  );
});
CasinoSidebar.displayName = "CasinoSidebar";

export default CasinoSidebar;
